import React, {useState, useEffect, useMemo} from "react";
import { Container, Row, Col} from "react-bootstrap";
import {
    englishData,
    sinhalaData,
    tamilData,
} from "../../dummyData/papersPageData";
import "./PapersPage.css";
import { useSelector } from "react-redux";
import PapersHome from "../../Components/HomePageMain/PapersHome/PapersHome";

const PapersPage = () => {
    const isProUser = useSelector((state) => state.user.isPro);
    const selectedLanguage = useSelector((state) => state.language.language);
    const [language, setLanguage] = useState(sinhalaData);


    useEffect(() => {
        switch (selectedLanguage.value) {
            case "english":
                setLanguage(englishData);
                break;
            case "tamil":
                setLanguage(tamilData);
                break;
            default:
                setLanguage(sinhalaData);
                break;
        }
    }, [selectedLanguage]);


 





    return (
      <div className="container-fluid d-flex justify-content-center align-items-center papers-page-section min-vh-100">
        <Container
          fluid
          className="d-flex container-fluid justify-content-center pt-5"
        >
          <div className={`${window.innerWidth < 992 ? "mt-5" : ""}`}></div>
          <PapersHome />
        </Container>
      </div>
    );
}

export default PapersPage;
